import React from 'react';
import styles from './TableBody.module.sass';

const TableBody = ({
    children
}) => {
    return <div className={styles['tablebody']}>
        { children }
    </div>;
}

export default TableBody;